import _ from "lodash";
window._ = _;
import { loadFonts } from "./webfontloader";
import store from "../store";
import router from "../router";
import axios from "../axios";
import Vuetify from "./vuetify";
import "./moment";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import Clipboard from "v-clipboard";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
window.axios = axios;
export function registerPlugins(app) {
    loadFonts();
    app.use(Vuetify)
        .use(store)
        .use(router)
        .use(ToastPlugin)
        .use(Clipboard)
        .component("VueDatePicker", VueDatePicker);
}
